/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_fallback",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fallbackHook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hookType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "hooks",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "postDispatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "destination",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "hook",
                        type: "address",
                    },
                ],
                internalType: "struct DomainRoutingHook.HookConfig[]",
                name: "configs",
                type: "tuple[]",
            },
        ],
        name: "setHooks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "supportsMetadata",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class FallbackDomainRoutingHook__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, _owner, _fallback, overrides) {
        return super.deploy(_mailbox, _owner, _fallback, overrides || {});
    }
    getDeployTransaction(_mailbox, _owner, _fallback, overrides) {
        return super.getDeployTransaction(_mailbox, _owner, _fallback, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=FallbackDomainRoutingHook__factory.js.map